import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class RewardResource extends AuthenticatedResource {
  static urlRoot = '/admin/rewards'

  readonly id: number | undefined = undefined;
  readonly title: string = '';
  readonly category: string = '';

  pk() {
    return this.id?.toString();
  }
}